import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import HTMLReactParser from "html-react-parser";
const UpcomingNFTDetails = () => {
  const { id } = useParams();
  const [coinData, setCoinData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://api.wlffinance.org/api/user/nft/view/${id}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setCoinData(data.data);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return;
  }
  return (
    <>
      <section className=" mobile-trade-section user-dashboard new-coin-details-area">
        <div className="row">
          <div className="col-12">
            <div className="trade-area-posce">
              <p className="btn btn-primary expired_time-css pb-2 mt-3">
                <FlipClockCountdown
                  to={coinData?.upcoming_time}
                  className="flip-clock"
                ></FlipClockCountdown>
              </p>
              <div className="new-coin-details py-5">
                <img
                  className="new-coin-logo"
                  src={`https://api.wlffinance.org/${coinData?.image}`}
                  alt=""
                />
                <div>
                  <div className="supply-coin">
                    <p>Supply NFT :</p>
                    <span>{coinData?.supply_coin}</span>
                  </div>
                </div>
              </div>

              <div className="new-coin-dis">
                <p> {coinData?.dis ? HTMLReactParser(coinData?.dis) : ""}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UpcomingNFTDetails;
